import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform<T>(values: T[], ...args: any[]): any {
    if (!values) {
      return;
    }

    const searchValue = args[0];
    const propName = args[1];

    if (!searchValue) {
      return values;
    }
    if (typeof +searchValue === 'number' && !isNaN(+searchValue)) {
      return values.filter((item) => item[propName] === +searchValue);
    }
    return values.filter((item) =>
      item[propName].toLowerCase().includes(searchValue.toLowerCase())
    );
  }
}
